import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class productoService {
    
    /******* QUERIES ******/
    async listarImpuesto() {
        const response = await axios
            .get(`${ERP}administracion/producto/impuesto`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listar() {
        const response = await axios
            .get(`${ERP}administracion/producto`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async autocomplete(nombre) {
        const response = await axios
        .get(`${ERP}administracion/producto/autocomplete/${nombre}`)
        .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarAnticipo() {
        const response = await axios
            .get(`${ERP}administracion/producto/anticipo`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarBarras(barcode) {
        const response = await axios
            .get(`${ERP}administracion/producto/barras?barcode=${barcode}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarConversionProductoPorId(idProducto) {
        const response = await axios
            .get(`${ERP}administracion/producto/producto-conversion/${idProducto}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarPorIdListaPrecio(idListaPrecio) {
        const response = await axios
            .get(`${ERP}administracion/producto/por-lista-precio/${idListaPrecio}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    
    
    async listarPorRequeremiento(idListaPrecio) {
        const response = await axios
            .get(`${ERP}administracion/producto/requeremiento-lista-producto/${idListaPrecio}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async productoPorlistarPorIdListaPrecio(idListaPrecio) {
        const response = await axios
            .get(`${ERP}administracion/producto/producto-por-lista-precio/${idListaPrecio}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}administracion/producto/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}administracion/producto/${id}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}administracion/producto/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}administracion/producto/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async stock(filter) {
        const response = await axios
            .get(`${ERP}administracion/producto/stock?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async Sinstock(filter) {
        const response = await axios
            .get(`${ERP}administracion/producto/sin-stock-cotizacion?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async stock_conversionMedida(filter) {
        const response = await axios
            .get(`${ERP}administracion/producto/stock-conversion-medida?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async barcode(filter) {
        const response = await axios
            .get(`${ERP}administracion/producto/barcode?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/

    async subirImagen(file) {
        const formData = new FormData();
        formData.append('file', file);
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };

        const response = await axios
            .post(`${ERP}administracion/producto/subir-imagen`, formData, config)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async subirCargaMasiva(file) {
        const formData = new FormData();
        formData.append('file', file);
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };

        const response = await axios
            .post(`${ERP}administracion/producto/subir-carga-masiva`, formData, config)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async registrar(data) {
        const response = await axios
            .post(`${ERP}administracion/producto`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    
    async registrarConversion(data) {
        const response = await axios
            .post(`${ERP}administracion/producto/conversion`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async registrarCargaMasiva(data) {
        const response = await axios
            .put(`${ERP}administracion/producto/registrar-carga-masiva`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}administracion/producto`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async desactivar(data) {
        const response = await axios
            .put(`${ERP}administracion/producto/desactivar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async eliminar(data) {
        const response = await axios
            .put(`${ERP}administracion/producto/eliminar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async eliminarConversion(idProducto) {
        const response = await axios
            .put(`${ERP}administracion/producto/eliminarConversion`, idProducto)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };


    async activar(data) {
        const response = await axios
            .put(`${ERP}administracion/producto/activar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async formatoCargaMasiva() {
        const response = await axios
            .get(`${ERP}administracion/producto/formato-carga-masiva`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new productoService();